import type { CachedOrg } from '@bb/automaton';
import type { ListingVisibility } from '@bb/domain/dist/types';
import { Link } from 'components';
import React from 'react';
import styled from 'styled-components';
import { SUPPORT_EMAIL } from 'utils';
import PanelBody from '../../../react-common/PanelBody';

/** Renders error panel if listing is inaccessible for some reason, otherwise renders children */
const InaccessibleListingPanelWrapper: React.FC<{
  dataLoaded?: boolean;
  listingFound: boolean;
  canBookAppointment: boolean;
  listingVisibility?: ListingVisibility;
  listingOrgFeatures?: CachedOrg['features'];
}> = ({
  dataLoaded,
  canBookAppointment,
  listingFound,
  listingVisibility,
  listingOrgFeatures,
  children,
}) => {
  let innerContent = null;
  if (dataLoaded) {
    if (!listingFound) {
      innerContent = (
        <>
          Listing could not be found. Please contact your brokerage for more
          information.
        </>
      );
    } else if (!listingOrgFeatures?.includes('APPOINTMENT')) {
      innerContent = (
        <>
          You do not have permissions to view this page. Please contact
          <Link href={`mailto:${SUPPORT_EMAIL}`}> {SUPPORT_EMAIL}</Link> for
          more information.
        </>
      );
    } else if (listingVisibility === 'pending') {
      innerContent = (
        <>
          Listing is not available for booking appointment. Please contact your
          brokerage for more information.
        </>
      );
    } else if (!canBookAppointment) {
      innerContent = <>You do not have permissions to this listing.</>;
    }

    if (innerContent) {
      return (
        <PanelBody fullHeight>
          <StyledErrorContainer>
            <h3>{innerContent}</h3>
          </StyledErrorContainer>
        </PanelBody>
      );
    }
  }

  return <>{children}</>;
};

const StyledErrorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default InaccessibleListingPanelWrapper;
